/**
 * Puente de UI para abrir el asistente existente (AiCopilotFab) con una pregunta desde otra pantalla.
 * No hace llamadas: solo emite un evento de ventana; quien responde es AiCopilotFab (askAssistant).
 */
export const ASK_AI_EVENT = 'quipus:ask-ai';

let lastQuestion = '';
let lastAt = 0;
/** Ventana en la que una pregunta idéntica se considera un doble envío (doble clic / Enter + clic). */
const DUPLICATE_WINDOW_MS = 1500;

export function askAi(question: string): void {
  const q = question.trim();
  if (!q) return;
  const now = Date.now();
  if (q === lastQuestion && now - lastAt < DUPLICATE_WINDOW_MS) return;
  lastQuestion = q;
  lastAt = now;
  window.dispatchEvent(new CustomEvent<{ question: string }>(ASK_AI_EVENT, { detail: { question: q } }));
}
